<template>
  <div class="Installation-process">
    <div
      class="activate-home"
      v-for="i in haveOrderImgSrc"
      :key="i.vulae"
    >
      <img
        class="activate-img"
        :src="i.imgUrl"
        alt
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
  },
  data () {
    return {
      haveOrderImgSrc: [
        {
          imgUrl: require('../assets/images/OBUHaveOrder/OBUHaveOrder_01.png'),
          value: 1
        },
        {
          imgUrl: require('../assets/images/OBUHaveOrder/OBUHaveOrder_02.png'),
          value: 2
        },
        {
          imgUrl: require('../assets/images/OBUHaveOrder/OBUHaveOrder_03.png'),
          value: 3
        },
        {
          imgUrl: require('../assets/images/OBUHaveOrder/OBUHaveOrder_04.png'),
          value: 4
        },
        {
          imgUrl: require('../assets/images/OBUHaveOrder/OBUHaveOrder_05.png'),
          value: 5
        },
        // {
        //   imgUrl: require('../assets/images/OBU激活主页/OBU激活主页_01.png')
        // }
      ]
    }
  },
  computed: {

  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
  },
  components: {
  }
}
</script>
<style scoped lang="scss">
.activate-home {
  position: relative;
  .activate-img {
    width: 100%;
    height: 100%;
  }
}
</style>